module.exports = __webpack_public_path__ + "static/media/Crossover.1229430b.svg";